import type { App } from '@keboola/api-client/developerPortal/types';
import { Badge } from '@keboola/design';

import { STAGE_LABELS } from '../constants';
import { getStackLabel, getStageBadge } from '../helpers';

/**
 * A component's stage badge (Beta / Experimental) plus the target stack of four Snowflake writers.
 *
 * - "Beta wins when both flags are set" lives in `getStageBadge`.
 * - Dark-on-tint colours are for AA contrast: the solid fills fail 4.5:1 at 12px
 *   (`packages/design/CONTRAST-AUDIT.md`) — don't swap them in.
 */
export function ComponentBadges({ app }: { app: Pick<App, 'id' | 'uiOptions'> }) {
  const stage = getStageBadge(app);
  const stack = getStackLabel(app.id);

  if (stage === null && stack === null) return null;

  return (
    <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-1">
      {stage === 'beta' && <Badge color="amber">{STAGE_LABELS.beta}</Badge>}
      {stage === 'experimental' && (
        <Badge color="purple-inverse">{STAGE_LABELS.experimental}</Badge>
      )}
      {stack !== null && <Badge color="cyan-inverse">{stack}</Badge>}
    </div>
  );
}
